import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, usePlugins } from "@adsk/bim360-matrix-react-components";
import T from "i18n-react";
import pco from "@adsk/bim360-matrix-react-components/es/plugins/pco";

const plugins = [pco];

const LinkedReferenceDescription = function({ link }) {
  const [name, setName] = useState(null);
  const { typeToPlugin } = usePlugins(plugins);
  const entityType = link.linkedItemType.toUpperCase();
  useEffect(() => {
    const plugin = typeToPlugin[entityType];
    if (plugin) {
      plugin.getEntitiesByIds([link.linkedItemId]).then(result => {
        setName(result.data[0].name);
      });
    }
  }, [link]);
  if (name) {
    return (<div><Text hasHTML>
      {T.translate("changeset.update.link", { referenceNew: name, entityType })}
    </Text></div>);
  }
  return null;
};
LinkedReferenceDescription.displayName = 'LinkedReferenceDescription';

LinkedReferenceDescription.propTypes = {
  link: PropTypes.shape({
    linkedItemId: PropTypes.string,
    linkedItemType: PropTypes.string,
  }),
};
export default LinkedReferenceDescription;
